import MemoryPanel from '../components/MemoryPanel';

// The company's memory, on Home.
export default function MemoryWidget() {
    return <MemoryPanel scope="company" />;
}
